export default __webpack_public_path__ + "static/media/genes@3x.4901106b.png";